/**
 * Header de marca con logo profesional de helado
 */
import React from "react";
import { Typography, Space } from "antd";

const { Title, Text } = Typography;

// Logo SVG personalizado de helado
const IceCreamLogo = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.3))",
    }}
  >
    {/* Cono del helado */}
    <path
      d="M24 38L16 28L32 28L24 38Z"
      fill="#D4A574"
      stroke="#B88652"
      strokeWidth="1.5"
    />
    {/* Líneas del cono */}
    <line x1="20" y1="32" x2="20" y2="28" stroke="#B88652" strokeWidth="1" />
    <line x1="24" y1="34" x2="24" y2="28" stroke="#B88652" strokeWidth="1" />
    <line x1="28" y1="32" x2="28" y2="28" stroke="#B88652" strokeWidth="1" />

    {/* Bola de helado principal (vainilla) */}
    <circle
      cx="24"
      cy="20"
      r="8"
      fill="#FFF8E1"
      stroke="#FFE082"
      strokeWidth="1.5"
    />

    {/* Bola de helado superior (chocolate) */}
    <circle
      cx="20"
      cy="14"
      r="6"
      fill="#6D4C41"
      stroke="#5D4037"
      strokeWidth="1.5"
    />

    {/* Bola de helado superior (fresa) */}
    <circle
      cx="28"
      cy="12"
      r="5"
      fill="#F8BBD0"
      stroke="#F48FB1"
      strokeWidth="1.5"
    />

    {/* Decoración - chips de chocolate */}
    <circle cx="22" cy="18" r="1.5" fill="#3E2723" />
    <circle cx="26" cy="19" r="1.5" fill="#3E2723" />
    <circle cx="24" cy="22" r="1.5" fill="#3E2723" />

    {/* Brillo en la bola principal */}
    <ellipse cx="22" cy="18" rx="2" ry="3" fill="rgba(255,255,255,0.4)" />
  </svg>
);

const BrandHeader = () => {
  return (
    <div
      style={{
        padding: "20px 16px",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Efecto de brillo sutil */}
      <div
        style={{
          position: "absolute",
          top: -50,
          right: -50,
          width: 150,
          height: 150,
          background:
            "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
          borderRadius: "50%",
        }}
      />

      <Space
        direction="vertical"
        size={6}
        style={{ width: "100%", position: "relative", zIndex: 1 }}
      >
        <Space
          size={14}
          align="center"
          style={{ justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px",
              background: "rgba(255,255,255,0.15)",
              borderRadius: "12px",
              backdropFilter: "blur(10px)",
            }}
          >
            <IceCreamLogo />
          </div>
          <Title
            level={3}
            style={{
              margin: 0,
              color: "white",
              fontWeight: 700,
              letterSpacing: "0.8px",
              fontFamily:
                "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
              textShadow:
                "0 3px 6px rgba(0,0,0,0.4), 0 0 20px rgba(255,255,255,0.1)",
              fontSize: "20px",
              lineHeight: "1.2",
            }}
          >
            Bizantino Gelato
          </Title>
        </Space>
        <Text
          style={{
            color: "rgba(255,255,255,0.95)",
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: "1.2px",
            textTransform: "uppercase",
            textShadow: "0 2px 4px rgba(0,0,0,0.3)",
            opacity: 0.95,
          }}
        >
          Sistema de Gestión Nutricional
        </Text>
      </Space>
    </div>
  );
};

export default BrandHeader;
